import $ from 'jquery';
import {getJsonScriptContent} from '../../utils/dom/getJsonScriptContent';
import '../plugins/elementEvents';

$(document).ready(() => {
    $.fn.phone = async function(options = {}) {
        if (this.length === 0) {
            // Return early if we're being called without matching elements.
            return;
        }

        // Dynamically import intlTelInput. We do this because it's a very large
        // file (more than 1 MB in size) and is only needed on pages that use
        // phone inputs or phone validation.
        await import('../../vendor/intlTelInput');

        const {preferredCountries = ''} = getJsonScriptContent(document.getElementById('intl-tel-input-options'));

        $.fn.intlTelInput.defaultOptions = {
            autoPlaceholder: 'off',
            preferredCountries,
        };

        const defaultOptions = {
            ...$.fn.intlTelInput.defaultOptions,
            ...$.fn.phone.defaults,
            ...options,
        };

        return this.each(function() {
            const $this = $(this);

            const elementOptions = {
                ...defaultOptions,
                initialCountry: $this.data('default-country') ?? defaultOptions.initialCountry,
                hiddenSubmit: $this.data('hidden-submit') ?? defaultOptions.hiddenSubmit,
                placeholderNumberType: $this.data('placeholder-number-type') ?? defaultOptions.placeholderNumberType,
            };

            if (elementOptions.hiddenSubmit) {
                // Hide the input
                $this.attr('type', 'hidden');

                // Create an element for intl-tel-input
                const $tel = $('<input/>').attr({
                    type: 'tel',
                    value: $this.val(),
                    placeholder: $this.attr('placeholder'),
                });

                // Copy classes
                $tel.attr('class', $this.attr('class'));

                // Insert the new input
                $tel.insertAfter($this);

                // Update the original field when the new field changes
                $tel.on('change', function() {
                    const number = $tel.intlTelInput('getNumber');
                    $this.val(number);

                    // Set the number to cause intl-tel-input.js to format it.
                    $tel.intlTelInput('setNumber', number);
                });

                $tel.intlTelInput(elementOptions);
            } else {
                $this.intlTelInput(elementOptions);

                $this.on('change', function() {
                    const number = $this.intlTelInput('getNumber');

                    // Set the number to cause intl-tel-input.js to format it.
                    $this.intlTelInput('setNumber', number);
                });
            }
        });
    };

    $.fn.phone.defaults = {
        hiddenSubmit: true,
    };

    function initializeIntlTelInput() {
        $('input.tel-input', this).phone();
    }

    $(document).ready(() => {
        // Disable Bootstrap dropdown keydown handler because it conflicts with
        // the intlTelInput dropdown. Note that this might have side-effects,
        // but we have not been able to find any so far.
        $(document).off('keydown.bs.dropdown.data-api');

        if (window.addElementReadyCallback) {
            addElementReadyCallback(initializeIntlTelInput);
        } else {
            initializeIntlTelInput.apply(document.body);
        }
    });
});
